<script setup lang="ts">
import { useCountries } from '@/composables/useCountries';
import type { Country } from '@/types/country';
import Dropdown from 'primevue/dropdown';
import { onMounted, ref, watch } from 'vue';

const props = defineProps<{
  modelValue: string;
  invalid?: boolean;
}>();

const emit = defineEmits(['update:modelValue']);

const { countries, loadCountries, getCountryByCode } = useCountries();
const selectedCountry = ref<Country | null>(null);

onMounted(async () => {
  await loadCountries();

  if (!props.modelValue) {
    emit('update:modelValue', 'CH');
  }

  selectedCountry.value = getCountryByCode(props.modelValue);
});

watch(selectedCountry, (newValue) => {
  if (newValue) {
    emit('update:modelValue', newValue.alpha2_code);
  }
});

watch(
  () => props.modelValue,
  (newValue) => {
    selectedCountry.value = getCountryByCode(newValue);
  },
);
</script>

<template>
  <Dropdown
    v-model="selectedCountry"
    :options="countries"
    :invalid="invalid"
    filter
    option-label="name"
    placeholder="Select a Country"
    class="md:w-14rem w-full"
    :virtual-scroller-options="{ itemSize: 38 }"
  >
    <template #value="slotProps">
      <div v-if="slotProps.value" class="align-items-center flex">
        <span class="mr-2">{{ slotProps.value.flag_emoji }}</span>
        <div>{{ slotProps.value.name }}</div>
        <span class="ml-2">({{ slotProps.value.currency_symbol }})</span>
      </div>
      <span v-else>
        {{ slotProps.placeholder }}
      </span>
    </template>
    <template #option="slotProps">
      <div class="align-items-center flex">
        <span class="mr-2">{{ slotProps.option.flag_emoji }}</span>
        <div>{{ slotProps.option.name }}</div>
        <span class="ml-2">({{ slotProps.option.currency_symbol }})</span>
      </div>
    </template>
  </Dropdown>
</template>
